<div class="wallet-transfer-page">
  <div class="header-section">
    <h1 class="title">Wallet Transfer</h1>
  </div>

  <div class="summary-card">
    <div class="card-header">
      <span class="card-title">OVERALL ACCOUNT SUMMARY</span>
    </div>
    <div class="summary-metrics">
      <div class="metric">
        <span class="metric-label">Main Balance</span>
        <span class="metric-value main-balance">{{ (exchangeBalance + casinoBalance) | number: "1.2-2" }}</span>
      </div>
      <div class="metric">
        <span class="metric-label">Exposure</span>
        <span class="metric-value exposure text-primary">{{ 400 | number: "1.2-2" }}</span>
      </div>
      <div class="metric">
        <span class="metric-label">Available to Bet</span>
        <span class="metric-value available text-success">{{ (exchangeBalance + casinoBalance - 400) | number: "1.2-2"
          }}</span>
      </div>
    </div>
  </div>

  <div class="main-content-grid">
    <div class="balances-section">
      <h2 class="section-title">Individual Wallet Balances</h2>
      <div class="balances-table-card">
        <table class="balances-table">
          <thead>
            <tr>
              <th>WALLET NAME</th>
              <th>MAIN BALANCE</th>
              <th>EXPOSURE</th>
              <th>AVAILABLE TO BET</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="wallet-name">
                  <span class="icon-container exchange-icon"><mat-icon>sync_alt</mat-icon></span>
                  <span>Exchange</span>
                </div>
              </td>
              <td class="balance-cell">{{ exchangeBalance | number: "1.2-2" }}</td>
              <td class="exposure-cell text-primary">{{ 200 | number: "1.2-2" }}</td>
              <td class="available-cell text-success">{{ (exchangeBalance - 200) | number: "1.2-2" }}</td>
            </tr>
            <tr>
              <td>
                <div class="wallet-name">
                  <span class="icon-container casino-icon"><mat-icon>sync_alt</mat-icon></span>
                  <span>Casino</span>
                </div>
              </td>
              <td class="balance-cell">{{ casinoBalance | number: "1.2-2" }}</td>
              <td class="exposure-cell text-primary">{{ 200 | number: "1.2-2" }}</td>
              <td class="available-cell text-success">{{ (casinoBalance - 200) | number: "1.2-2" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="transfer-section">
      <div class="transfer-card">
        <div class="card-header">
          <span class="icon-container header-icon"><mat-icon>account_balance_wallet</mat-icon></span>
          <span class="card-title">Transfer Funds</span>
        </div>

        <form [formGroup]="form" (submit)="handleSubmit()" class="transfer-form">
          <div class="form-group">
            <label class="form-label">FROM</label>
            <div class="select-wrapper">
              <mat-icon class="wallet-prefix-icon">account_balance_wallet</mat-icon>
              <select (change)="onFromWalletChange($event)">
                <option value="main_to_secondary" [selected]="isExchange">
                  Exchange ({{ exchangeBalance | number: "1.2-2" }})
                </option>
                <option value="secondary_to_main" [selected]="!isExchange">
                  Casino ({{ casinoBalance | number: "1.2-2" }})
                </option>
              </select>
              <mat-icon class="dropdown-icon">expand_more</mat-icon>
            </div>
          </div>

          <div class="swap-container">
            <button type="button" class="btn-swap" (click)="swapWallets()">
              <mat-icon>swap_vert</mat-icon>
            </button>
          </div>

          <div class="form-group">
            <label class="form-label">TO</label>
            <div class="select-wrapper">
              <mat-icon class="wallet-prefix-icon">account_balance_wallet</mat-icon>
              <select (change)="onToWalletChange($event)">
                <option value="secondary_to_main" [selected]="isExchange">
                  Casino ({{ casinoBalance | number: "1.2-2" }})
                </option>
                <option value="main_to_secondary" [selected]="!isExchange">
                  Exchange ({{ exchangeBalance | number: "1.2-2" }})
                </option>
              </select>
              <mat-icon class="dropdown-icon">expand_more</mat-icon>
            </div>
          </div>

          <div class="form-group amount-group">
            <label class="form-label">AMOUNT</label>
            <div class="amount-input-wrapper">
              <input type="text" formControlName="AMOUNT" numbersOnly [min]="1" [max]="fromBalance" placeholder="0" />
              <div class="amount-controls">
                <button type="button" class="btn-ctrl" (click)="adjustAmount('decrease')">-</button>
                <button type="button" class="btn-ctrl" (click)="adjustAmount('increase')">+</button>
                <button type="button" class="btn-max" (click)="setMax()">MAX</button>
              </div>
            </div>
            @if (isBalanceInsufficient) {
            <span class="error-message">Insufficient Funds</span>
            }
          </div>

          <div class="form-group password-group">
            <div class="password-input-wrapper disabled-look">
              <input type="password" placeholder="Password" disabled />
              <mat-icon class="visibility-icon">visibility</mat-icon>
            </div>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-submit bg-primary text-secondary"
              [disabled]="isTransferInvalid || (isLoading$ | async)">
              {{ (isLoading$ | async) ? "Transferring..." : "Confirm Transfer" }}
              <mat-icon class="submit-icon">arrow_forward</mat-icon>
            </button>
            <button type="button" class="btn-cancel" (click)="resetForm()">Cancel</button>
          </div>

          <mat-progress-bar [class.hidden]="!(isLoading$ | async)" color="accent"
            mode="indeterminate"></mat-progress-bar>
        </form>

        <div class="notice" [ngClass]="{
            'success-notice': transferNotice() === 'success',
            'error-notice': transferNotice() === 'error',
            hidden: !transferNotice(),
          }">
          <div class="notice-header"><mat-icon (click)="closeNotice()">close</mat-icon></div>
          <mat-icon class="icon">{{ transferNotice() === "success" ? "check" : "close" }}</mat-icon>
          <b class="notice-title">
            {{ selectedAmount | number: "1.2-2" }}
            {{ transferNotice() === "success" ? "transferred" : "transfer not successful" }}
          </b>
          <span class="notice-description">{{ fromDescription }} <mat-icon>east</mat-icon> {{ toDescription }}</span>
        </div>

      </div>
    </div>
  </div>
</div>